import {cn} from '@/utils';
import React, {HTMLAttributes} from 'react';

type LabelProps = {
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
} & Omit<HTMLAttributes<HTMLLabelElement>, 'size'>;

const Label = ({children, size = 'sm', ...props}: LabelProps) => {
  return (
    <label className={cn(['text-[#000000]', TYPE_SIZE[size]])} {...props}>
      {children}
    </label>
  );
};

export default Label;

const TYPE_SIZE = {
  sm: 'text-sm font-medium',
  md: 'text-md font-medium',
  lg: 'text-lg font-medium',
};
